import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-list-empty',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="pp-list-empty" [class.pp-list-empty--compact]="compact">
      <span class="pp-icon-tile" [class.pp-icon-tile--lg]="!compact" [style.--tile-color]="color">
        <i class="pi" [ngClass]="hasFilters ? 'pi-filter-slash' : icon"></i>
      </span>
      <p class="pp-list-empty__title">{{ hasFilters ? filteredHeading : heading }}</p>
      <p class="pp-list-empty__text" *ngIf="hasFilters ? filteredText : text">
        {{ hasFilters ? filteredText : text }}
      </p>
      <button *ngIf="hasFilters && showClear" type="button" class="pp-btn" (click)="clearFilters.emit()">
        <i class="pi pi-times"></i> Clear filters
      </button>
      <ng-content></ng-content>
    </div>
  `,
  styles: [':host { display: block; }'],
})
export class ListEmptyComponent {
  @Input() icon = 'pi-inbox';
  @Input() color = '#6366f1';
  @Input() heading = 'Nothing here yet';
  @Input() text = '';
  @Input() hasFilters = false;
  @Input() filteredHeading = 'No results match these filters';
  @Input() filteredText = 'Try a different search or remove a filter.';
  @Input() showClear = true;
  @Input() compact = false;

  @Output() clearFilters = new EventEmitter<void>();
}
